import { render } from "./navigationelement.vue?vue&type=template&id=40e24b10&scoped=true"
import script from "./navigationelement.vue?vue&type=script&lang=js"
export * from "./navigationelement.vue?vue&type=script&lang=js"

import "./navigationelement.vue?vue&type=style&index=0&id=40e24b10&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e24b10"]])

export default __exports__